// @ts-ignore - React import for JSX compatibility
import React from 'react';
import styled from 'styled-components';
import IntlParent from './shared/providers/IntlParent';
import { StateContextParent } from './shared/contexts/StateContextParent/StateContextParent';
import { GeneralProvider } from './shared/contexts/GeneralContext';
import { initializeGoogleAnalytics } from './shared/helpers/analitycs';
import Routes from './routes';

const AppContainer = styled.div`
  background-color: #fafafa;
  // min-height: 100vh;
`;

interface IApp {
  initialState?: object;
}

function App({ initialState }: IApp) {
  initializeGoogleAnalytics();

  return (
    <AppContainer>
      <IntlParent initialState={{ initialState }}>
        <StateContextParent>
          <GeneralProvider>
            <Routes />
          </GeneralProvider>
        </StateContextParent>
      </IntlParent>
    </AppContainer>
  );
}

export default App;
